import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-seo-off-page-campaigns-reviews',
  templateUrl: './seo-off-page-campaigns-reviews.component.html',
  styleUrls: ['./seo-off-page-campaigns-reviews.component.css'],
})
export class SeoOffPageCampaignsReviewsComponent implements OnInit {
  id: string = '';
  campaign: any = null;
  loading: boolean = true;
  saving: boolean = false;
  url_aux: string = 'seoOffpageCampaigns';
  url: string = 'seoKeywordDiscoveries';
  selectedKeyword: number | null = null;
  reviewNotes: string = '';

  locations = [
    { value: 'orlando_fl', label: 'Orlando, FL' },
    { value: 'tampa_fl', label: 'Tampa, FL' },
    { value: 'naples_fl', label: 'Naples, FL' },
    { value: 'west_palm_beach_fl', label: 'West Palm Beach, FL' },
    { value: 'boca_raton_fl', label: 'Boca Raton, FL' },
  ];

  channels = [
    { value: 'google_seo', label: 'Google SEO' },
    { value: 'google_ads', label: 'Google Ads' },
    { value: 'facebook_ads', label: 'Facebook Ads' },
    { value: 'instagram_ads', label: 'Instagram Ads' },
    { value: 'tiktok_ads', label: 'TikTok Ads' },
    { value: 'linkedin_ads', label: 'LinkedIn Ads' },
    { value: 'twitter_ads', label: 'Twitter Ads' },
    { value: 'other', label: 'Other' },
  ];

  universes = [
    { value: 'courier', label: 'Courier' },
    { value: 'runner', label: 'Runner' },
  ];

  categories = [
    { value: 'company_brand', label: 'Company Brand' },
    { value: 'same_day_courier', label: 'Same-Day Courier' },
    { value: 'rush_courier', label: 'Rush Courier' },
    { value: 'scheduled_courier', label: 'Scheduled Courier' },
    { value: 'vip_courier', label: 'VIP Courier' },
    { value: 'concierge_courier', label: 'Concierge Courier' },
    { value: 'business_courier', label: 'Business Courier' },
    { value: 'legal_services', label: 'Legal Services' },
    { value: 'long_distance_courier', label: 'Long Distance Courier' },
    { value: 'last_mile_services', label: 'Last Mile Services' },
    { value: 'local_courier_services', label: 'Local Courier Services' },
  ];

  conversionGoals = [
    {
      value: 'phone_calls_quote_requests',
      label: 'Phone Calls & Quote Requests',
    },
    { value: 'online_bookings', label: 'Online Bookings' },
    { value: 'contact_form_submissions', label: 'Contact Form Submissions' },
    { value: 'email_inquiries', label: 'Email Inquiries' },
    { value: 'live_chat_conversations', label: 'Live Chat Conversations' },
    { value: 'get_a_quote_requests', label: 'Get a Quote Requests' },
    { value: 'quote_requests', label: 'Quote Requests' },
    { value: 'bookings', label: 'Bookings' },
    { value: 'customer_app_downloads', label: 'Customer App Downloads' },
    { value: 'customer_app_signups', label: 'Customer App Signups' },
    { value: 'business_account_signups', label: 'Business Account Signups' },
    { value: 'driver_signups', label: 'Driver Signups' },
  ];

  keywordIntents = [
    { value: 'high_intent_local', label: 'High-Intent Local' },
    { value: 'broad_commercial', label: 'Broad Commercial' },
    { value: 'mixed_high_intent', label: 'Mixed High-Intent' },
    { value: 'informational', label: 'Informational' },
    { value: 'navigational', label: 'Navigational' },
    { value: 'brand_intent', label: 'Brand Intent' },
  ];

  keywordModes = [
    { value: 'ai_optimized', label: 'AI Optimized' },
    { value: 'revenue_opportunities', label: 'Revenue Opportunities' },
    { value: 'high_commercial_value', label: 'High Commercial Value' },
    { value: 'conversion_focused', label: 'Conversion Focused' },
    { value: 'high_volume', label: 'High Volume' },
    { value: 'authority_building', label: 'Authority Building' },
  ];

  competitionTargets = [
    { value: 'strategic_mix', label: 'Strategic Mix' },
    { value: 'medium_competition', label: 'Medium Competition' },
    { value: 'high_competition', label: 'High Competition' },
    { value: 'market_leader_keywords', label: 'Market Leader Keywords' },
    { value: 'all', label: 'All' },
  ];

  objectives = [
    { value: 'conversion_growth', label: 'Conversion Growth' },
    { value: 'ranking_growth', label: 'Ranking Growth' },
    { value: 'authority_growth', label: 'Authority Growth' },
    { value: 'strategic_growth_mix', label: 'Strategic Growth Mix' },
  ];

  landingStrategies = [
    { value: 'homepage', label: 'Homepage' },
    { value: 'main_landing', label: 'Main Landing' },
    { value: 'city_page', label: 'City Page' },
    { value: 'service_page', label: 'Service Page' },
    { value: 'industry_page', label: 'Industry Page' },
    { value: 'local_hub', label: 'Local Hub' },
    { value: 'other', label: 'Other' },
    { value: 'system_suggests', label: 'System suggests' },
  ];

  urlStrategies = [
    { value: 'homepage', label: 'Homepage' },
    { value: 'main_landing', label: 'Main Landing' },
    { value: 'city_page', label: 'City Page' },
    { value: 'service_page', label: 'Service Page' },
    { value: 'industry_page', label: 'Industry Page' },
    { value: 'local_hub', label: 'Local Hub' },
    { value: 'other', label: 'Other' },
    { value: 'system_suggests', label: 'System suggests' },
  ];

  actionTypes = [
    { value: 'homepage', label: 'Homepage' },
    { value: 'main_landing', label: 'Main Landing' },
    { value: 'city_page', label: 'City Page' },
    { value: 'service_page', label: 'Service Page' },
    { value: 'industry_page', label: 'Industry Page' },
    { value: 'local_hub', label: 'Local Hub' },
    { value: 'other', label: 'Other' },
    { value: 'system_suggests', label: 'System suggests' },
  ];

  priorities = [
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' },
    { value: 'critical', label: 'Critical' },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
      if (this.id) {
        this.fetchCampaign();
      } else {
        this.messageService.add('Invalid Campaign ID', 'danger');
        this.goBack();
      }
    });
  }

  fetchCampaign(): void {
    this.loading = true;
    this.dataService.getData(`${this.url}/${this.id}`).subscribe(
      (response: any) => {
        if (response.rst && response.data) {
          this.campaign = response.data;
        } else {
          this.messageService.add(
            response.msg || 'Error loading campaign',
            'danger',
          );
        }
        this.loading = false;
      },
      (error) => {
        this.messageService.add('Failed to connect to the server.', 'danger');
        this.loading = false;
      },
    );
  }

  toggleKeywordStatus(index: number, event: any): void {
    const isChecked = event.target.checked;
    if (
      this.campaign &&
      this.campaign.keywords &&
      this.campaign.keywords[index]
    ) {
      this.campaign.keywords[index].status = isChecked ? 'active' : 'disabled';
    }
  }

  isKeywordSelected(status: string): boolean {
    return status === 'active';
  }

  getKeywordStatusBadgeClass(status: string): string {
    switch (status) {
      case 'active':
        return 'badge-success'; // usually green/selected
      case 'disabled':
      case 'paused':
        return 'badge-light'; // generic or suggested
      default:
        return 'badge-secondary';
    }
  }

  getKeywordStatusLabel(status: string): string {
    switch (status) {
      case 'active':
        return 'Selected';
      case 'disabled':
      case 'paused':
        return 'Suggested';
      default:
        return 'Review';
    }
  }

  selectAll(val: boolean): void {
    if (this.campaign && this.campaign.keywords) {
      this.campaign.keywords.forEach((kw: any) => {
        kw.status = val ? 'active' : 'disabled';
      });
    }
  }

  selectKeyword(index: number): void {
    this.selectedKeyword = this.selectedKeyword === index ? null : index;
  }

  toggleSelectAll(event: any): void {
    this.selectAll(event.target.checked);
  }

  toggleKeywordStatusByIndex(index: number): void {
    if (
      this.campaign &&
      this.campaign.keywords &&
      this.campaign.keywords[index]
    ) {
      const current = this.campaign.keywords[index].status;
      this.campaign.keywords[index].status =
        current === 'active' ? 'disabled' : 'active';
    }
  }

  askAiReconsider(): void {
    // Placeholder: trigger AI reconsideration logic
    this.messageService.add('AI reconsideration requested.', 'info');
  }

  addReviewNote(): void {
    // Focus the review notes textarea
    const el = document.querySelector('.review-notes-area') as HTMLElement;
    if (el) el.focus();
  }

  get aiActiveCount(): number {
    if (!this.campaign?.keywords) return 0;
    return this.campaign.keywords.filter(
      (kw: any) => kw.aiRecommendation === 'active' || kw.status === 'active',
    ).length;
  }

  get totalEstVolume(): string {
    if (!this.campaign?.keywords) return '0';
    const sum = this.campaign.keywords.reduce(
      (acc: number, kw: any) => acc + (parseFloat(kw.estVolume) || 0),
      0,
    );
    return sum >= 1000 ? (sum / 1000).toFixed(1) + 'K' : sum.toString();
  }

  get avgOpportunityScore(): number {
    if (!this.campaign?.keywords || this.campaign.keywords.length === 0)
      return 0;
    const sum = this.campaign.keywords.reduce(
      (acc: number, kw: any) => acc + (parseFloat(kw.oppScore) || 0),
      0,
    );
    return Math.round(sum / this.campaign.keywords.length);
  }

  get allSelected(): boolean {
    if (!this.campaign?.keywords || this.campaign.keywords.length === 0)
      return false;
    return this.campaign.keywords.every((kw: any) => kw.status === 'active');
  }

  getRegistryBadgeClass(registryMatch: string): string {
    if (!registryMatch) return 'registry-net-new';
    const val = registryMatch.toLowerCase();
    if (val.includes('existing') && val.includes('bank'))
      return 'registry-existing-banked';
    if (val.includes('existing') && val.includes('active'))
      return 'registry-existing-active';
    if (val.includes('previous') || val.includes('rejected'))
      return 'registry-previous-rejected';
    if (val.includes('related')) return 'registry-related-demand';
    return 'registry-net-new';
  }

  getAiRecBadgeClass(recommendation: string): string {
    if (!recommendation) return 'ai-rec-bank';
    const val = recommendation.toLowerCase();
    if (val === 'active') return 'ai-rec-active';
    if (val === 'consider') return 'ai-rec-consider';
    return 'ai-rec-bank';
  }

  getAiRecLabel(recommendation: string): string {
    if (!recommendation) return 'Bank';
    const val = recommendation.toLowerCase();
    if (val === 'active') return 'Active';
    if (val === 'consider') return 'Consider';
    return 'Bank';
  }

  save(): void {
    if (!this.campaign) return;

    this.saving = true;
    const payload = {
      keywords: this.campaign.keywords,
      status: 'approved',
    };

    this.dataService.putData(`${this.url}/${this.id}/approve`, payload).subscribe(
      (response: any) => {
        this.saving = false;
        if (response.rst) {
          this.messageService.add(
            'Campaign keywords saved successfully',
            'success',
          );
          // Navigate back or to view
          this.router.navigateByUrl(
            '/marketing/seo/offPageCampaigns/urlMapping',
          );
        } else {
          this.messageService.add(
            response.msg || 'Error saving campaign',
            'danger',
          );
        }
      },
      (error) => {
        this.saving = false;
        this.messageService.add('Server error while saving.', 'danger');
      },
    );
  }

  goBack(): void {
    this.router.navigateByUrl('marketing');
  }

  get totalSuggested(): number {
    return this.campaign?.keywords?.length || 0;
  }

  get totalSelected(): number {
    if (!this.campaign?.keywords) return 0;
    return this.campaign.keywords.filter((kw: any) => kw.status === 'active')
      .length;
  }

  getChannelLabel(value: string): string {
    return this.channels.find((c) => c.value === value)?.label || value;
  }

  getLocationLabel(value: string): string {
    return this.locations.find((l) => l.value === value)?.label || value;
  }

  getUniverseLabel(value: string): string {
    return this.universes.find((u) => u.value === value)?.label || value;
  }

  getCategoryLabel(value: string): string {
    return this.categories.find((c) => c.value === value)?.label || value;
  }

  getConversionGoalLabel(value: string): string {
    return this.conversionGoals.find((c) => c.value === value)?.label || value;
  }

  getKeywordIntentLabel(value: string): string {
    return this.keywordIntents.find((k) => k.value === value)?.label || value;
  }

  getKeywordModeLabel(value: string): string {
    return this.keywordModes.find((k) => k.value === value)?.label || value;
  }

  getCompetitionTargetLabel(value: string): string {
    return (
      this.competitionTargets.find((c) => c.value === value)?.label || value
    );
  }

  getObjectiveLabel(value: string): string {
    return this.objectives.find((o) => o.value === value)?.label || value;
  }

  getLandingStrategyLabel(value: string): string {
    return (
      this.landingStrategies.find((l) => l.value === value)?.label || value
    );
  }

  getActionTypeLabel(value: string): string {
    return this.actionTypes.find((a) => a.value === value)?.label || value;
  }

  getPriorityLabel(value: string): string {
    return this.priorities.find((p) => p.value === value)?.label || value;
  }
}
